import React from 'react';
import {ControlPosition, Map, MapControl} from '@vis.gl/react-google-maps';

import {UndoRedoControl} from './undo-redo-control.tsx';
import {useDrawingManager} from './use-drawing-manager.tsx';

const defaultCenter = {
  lat: 39.8283, // Center of the continental US
  lng: -98.5795,
};

const DrawingExample = () => {
  const drawingManager = useDrawingManager();

  return (
    <>
      <Map
        defaultZoom={5}
        defaultCenter={defaultCenter}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
      />

      <MapControl position={ControlPosition.TOP_CENTER}>
        <UndoRedoControl drawingManager={drawingManager} />
      </MapControl>
    </>
  );
};

export default DrawingExample;